import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'
import {routes} from "./router";
import {store} from './store/store'
import {helperFunctions} from "./helperFunctions";
import {Permissions} from "./config";

import Vuelidate from 'vuelidate';
import Vue2Filters from 'vue2-filters';
import DashboardGraph from './components/graphs/DashboardGraph';

//components import
import MyInfo from './components/extra/Info';
import InvoiceFormModal from './components/invoice/FormModal'
import InvoiceReceiptFormModal from './components/invoice/InvoiceReceipt'
import CreditDebitNote from './components/invoice/CreditDebitNote';

Vue.use(Vuelidate);
Vue.use(VueRouter);
Vue.use(Vue2Filters);
Vue.use(VueAxios, axios);
Vue.use(require('vue-moment'));

axios.defaults.baseURL = 'https://nhafatura.cv/api/public/api/'; //Server domain
// axios.defaults.baseURL = 'http://127.0.0.1:8000/api/'; // Local domain
// axios .defaults.baseURL = process.env.VUE_APP_BASE_URL;


Vue.component('my-info', MyInfo);
Vue.component('invoice-form-modal', InvoiceFormModal);
Vue.component('invoice-receipt-form-modal', InvoiceReceiptFormModal);
Vue.component('credit-debit-note', CreditDebitNote);
Vue.component('dashboard-graph', DashboardGraph);


// axios.defaults.baseURL = 'http://dev.laciftech.cv/server/api/';

// import 'moment/locale/pt';
let moment = require('moment-timezone');

Vue.config.productionTip = false;
export const eventBus = new Vue();

const router = new VueRouter({
  // mode: 'history',
  routes,
});


//Mixins
Vue.mixin(helperFunctions);
Vue.mixin(Permissions);


//Directive
Vue.directive('visible', function(el, binding) {
  el.style.visibility = binding.value ? 'visible' : 'hidden';
});


//Filters
Vue.filter('moneyCVE', function(value){
  if (typeof value !== "number") {
    return value;
  }
  let formatter = new Intl.NumberFormat('pt-PT', {
    style: 'currency',
    currency: 'Esc',
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(value).tz("Atlantic/Cape_Verde").format("DD/MM/YYYY");
  }
});

Vue.filter('formatDateHour', function(value) {
  if (value) {
    return moment(value).tz("Atlantic/Cape_Verde").format("hh:mm DD/MM/YYYY");
  }
});

router.beforeEach((to, from, next) => {
  console.log('route>>>>beforeEach[to]:', to);
  console.log('route>>>>beforeEach[from]:', from);
  console.log('route>>>>to.name[from]:', to.name);
  if(to.name === 'storage'){
    console.log('<<<<<[storage]>>>>>>:');
  }else if(to.matched.some(record => record.meta.requiresAuth)){

    if(to.matched.some(record => record.meta.requiresAdmin)){
      if(!store.getters.loggedIn) {
        // console.log('route>login');
        next({ name: 'login' })
      }
      else if(!store.getters.isLoggedUserSuperAdmin){
        // console.log('route>dashboard');
        next({ name: 'dashboard' })
      }
      else{
        // console.log('route>next');
        next();
      }

    }else if(!store.getters.loggedIn) {
      // console.log('route>2login');
      next({name: 'login'});

    }else{
      // console.log('route>2next');
      next()
    }
  }else{
    if(store.getters.loggedIn) {
      // console.log('route>2dashboard');
      // next({ name: 'dashboard' })
    }else{
      // console.log('route>3next');
      next()
    }
  }

});


axios.interceptors.response.use(
    response => response,
    (error) => {
      if (error.response.status === 401) {
        // Clear token and redirect
        store.dispatch('storeToken', null);
        if(router.currentRoute.meta.requiresAuth){
          router.push({name: 'login'})
        }
        //
      }

      return Promise.reject(error);
    },
);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
